import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export const Ribbon = () => {
  const { t } = useLang();
  return (
    <section className="bg-tricolor-green py-4 md:py-5 overflow-hidden" data-testid="marquee-ribbon">
      <Marquee speed={45} gradient={false} autoFill>
        {t.marquee.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-bold text-lg md:text-2xl tracking-tight text-white px-6">{item}</span>
            <span className="text-white/50 text-lg">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
